import { Pipe, PipeTransform } from '@angular/core';

import { QUOTE_STATUSES, QuoteStatus } from '@lockton-apps/shared/interfaces';

@Pipe({
  name: 'quoteStatusColor',
  standalone: true,
})
export class QuoteStatusColorPipe implements PipeTransform {
  iconMap = new Map<QuoteStatus, string>([
    [QUOTE_STATUSES.FormComplete, 'orange'],
    [QUOTE_STATUSES.OnHold, 'orange'],
    [QUOTE_STATUSES.HealthEvaluationActive, 'orange'],
    [QUOTE_STATUSES.Quoted, 'orange'],
    [QUOTE_STATUSES.AwaitingPayment, 'orange'],
    [QUOTE_STATUSES.Complete, 'green'],
    [QUOTE_STATUSES.QuoteError, 'red'],
  ]);

  transform(value: QuoteStatus): string {
    return this.iconMap.get(value) || 'grayMedium';
  }
}
